import {
  AssetRoutineState,
  RoutineState,
  WorkflowPageConfig,
  WorkflowQuestionConfig,
  WorkspaceAsset,
} from '@gripp/shared-logic';
import { useMemo } from 'react';
import { View } from 'react-native';
import { Text } from 'react-native-paper';
import { tokens } from '../../../crop-circle/tokens';
import { useFormContext } from '../../../forms';
import { stylesCropCircle } from './styles';
import { WorkflowExecutionQuestion } from './workflowExecutionQuestion';

type WorkflowExecutionPageProps = {
  page: WorkflowPageConfig;
  workspaceAsset: WorkspaceAsset;
  toggleProcessing?: (value: boolean) => void;
  currentState: AssetRoutineState<RoutineState> | undefined;
  isIssueEditRoutine?: boolean;
};

interface QuestionResponse {
  index: number;
  config: WorkflowQuestionConfig;
}

export const WorkflowExecutionPage = (props: WorkflowExecutionPageProps) => {
  const { getValues } = useFormContext();
  const fields = getValues('responses');

  const questionResponses = useMemo<QuestionResponse[]>(
    () =>
      [...props.page.questions]
        .sort((a, b) => a.order - b.order)
        .map((question) => ({
          index: fields.findIndex(
            (field: any) => field.questionId === question.id
          ),
          config: question,
        })),
    [props.page.questions, fields]
  );

  return (
    <>
      {props.page.instructions && (
        <View style={stylesCropCircle.instructionsContainer}>
          <Text style={tokens.typography.body.mediumEmphasised}>
            {props.page.instructions}
          </Text>
        </View>
      )}
      {questionResponses.map((response, index) => (
        <WorkflowExecutionQuestion
          key={`question_${index}`}
          config={response.config}
          questionIndex={index}
          responseIndex={response.index}
          workspaceAsset={props.workspaceAsset}
          toggleProcessing={props.toggleProcessing}
          currentState={props.currentState}
          isIssueEditRoutine={props.isIssueEditRoutine}
        />
      ))}
    </>
  );
};
